import {useQuery} from 'react-query';
import getStorePlans from '.';

const useGetPlans = () => {
  const {data, isLoading} = useQuery(['get-store-plans'], getStorePlans);

  return {data, isLoading};
};

export default useGetPlans;
